export default [{
    path: '/admin/clinic/reception/workbench',
    name: 'ClinicWorkbench',
    component: () => import('@/views/clinic/reception/workbench'),
    meta: {
      title: '前台-工作台',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/drug',
    name: 'ClinicDrug',
    component: () => import('@/views/clinic/pharmacy/drug'),
    meta: {
      title: '药房-药品管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/setting/index',
    name: 'ClinicSetting',
    component: () => import('@/views/clinic/setting/index'),
    children: [{
      path: '/admin/clinic/setting/hospital/patient',
      name: 'ClinicPatient',
      component: () => import('@/views/clinic/setting/hospital/patient'),
      meta: {
        title: '患者设置',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/hospital/clinic_config',
      name: 'ClinicConfig',
      component: () => import('@/views/clinic/setting/hospital/clinic_config'),
      meta: {
        title: '医馆设置',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/hospital/more',
      name: 'ClinicSettingMore',
      component: () => import('@/views/clinic/setting/hospital/more'),
      meta: {
        title: '业务设置',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/hospital/appointment',
      name: 'ClinicSettingAppointment',
      component: () => import('@/views/clinic/setting/hospital/appointment'),
      meta: {
        title: '预约设置',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/hospital/cashier',
      name: 'ClinicSettingCashier',
      component: () => import('@/views/clinic/setting/hospital/cashier'),
      meta: {
        title: '收银设置',
      }
    }, {
      path: '/admin/clinic/setting/hospital/print',
      name: 'ClinicPrint',
      component: () => import('@/views/clinic/setting/hospital/print'),
      meta: {
        title: '打印设置',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/hospital/express',
      name: 'ClinicSettingExpress',
      component: () => import('@/views/clinic/setting/hospital/express'),
      meta: {
        title: '配送设置',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/hospital/surcharge',
      name: 'ClinicSettingSurcharge',
      component: () => import('@/views/clinic/setting/hospital/surcharge'),
      meta: {
        title: '附加费设置',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/hospital/drug_taboos',
      name: 'ClinicDrugTaboos',
      component: () => import('@/views/clinic/setting/hospital/drug_taboos'),
      meta: {
        title: '配伍禁忌',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/hospital/set_prescription',
      name: 'ClinicSetPrescription',
      component: () => import('@/views/clinic/setting/hospital/set_prescription'),
      meta: {
        title: '开方设置',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/hospital/deliver_goods',
      name: 'ClinicSetDeliverGoods',
      component: () => import('@/views/clinic/setting/hospital/deliver_goods'),
      meta: {
        title: '收货地址',
        keepAlive: false
      }
    }]
  },
  {
    path: '/admin/clinic/setting/patient/index',
    name: 'ClinicPatientIndex',
    component: () => import('@/views/clinic/patient/index.vue'),
    children: [{
      path: '/admin/clinic/setting/patient/list',
      name: 'ClinicPatientList',
      component: () => import('@/views/clinic/patient/list.vue'),
      meta: {
        title: '患者管理',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/patient/blacklist',
      name: 'ClinicPatientBlackList',
      component: () => import('@/views/clinic/patient/blacklist.vue'),
      meta: {
        title: '黑名单',
        keepAlive: false
      }
    }]
  },
  {
    path: '/admin/clinic/setting/patient/indexDtl',
    name: 'ClinicPatientDtl',
    component: () => import('@/views/clinic/patient/indexDtl'),
    children: [{
      path: '/admin/clinic/setting/patient/detail',
      name: 'ClinicPatientDetail',
      component: () => import('@/views/clinic/patient/detail.vue'),
      meta: {
        title: '患者详情',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/patient/consultationList',
      name: 'ClinicConsultationList',
      component: () => import('@/views/clinic/patient/consultationList.vue'),
      meta: {
        title: '就诊记录',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/setting/patient/tabFlow',
      name: 'ClinicPatientTabFlow',
      component: () => import('@/views/clinic/patient/tabFlow.vue'),
      meta: {
        title: '交易记录',
        keepAlive: false

      }
    }, {
      path: '/admin/clinic/patient/aboutRecordList',
      name: 'ClinicPatientAboutRecordList',
      component: () => import('@/views/clinic/patient/about_record_list.vue'),
      meta: {
        title: '预约记录',
        keepAlive: false
      }
    }]
  },
  {
    path: '/admin/clinic/setting/patient/editDetail',
    name: 'ClinicPatientEditDetail',
    component: () => import('@/views/clinic/patient/editDetail.vue'),
    meta: {
      title: '编辑患者',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/price',
    name: 'ClinicPharmacyPrice',
    component: () => import('@/views/clinic/pharmacy/price.vue'),
    meta: {
      title: '调价管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/purchase',
    name: 'ClinicPharmacyPurchase',
    component: () => import('@/views/clinic/pharmacy/purchase.vue'),
    meta: {
      title: '采购管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/warehousing',
    name: 'ClinicPharmacyWarehousing',
    component: () => import('@/views/clinic/pharmacy/warehousing.vue'),
    meta: {
      title: '入库管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/out_warehouse',
    name: 'ClinicPharmacyOutWarehouse',
    component: () => import('@/views/clinic/pharmacy/out_warehouse.vue'),
    meta: {
      title: '出库管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/inventory',
    name: 'ClinicPharmacyInventory',
    component: () => import('@/views/clinic/pharmacy/inventory.vue'),
    meta: {
      title: '盘点管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/enterprise',
    name: 'ClinicPharmacyEnterprise',
    component: () => import('@/views/clinic/pharmacy/enterprise.vue'),
    meta: {
      title: '厂商管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/doctor/index',
    name: 'ClinicDoctorIndex',
    component: () => import('@/views/clinic/doctor/index'),
    children: [{
        path: '/admin/clinic/doctor/list',
        name: 'ClinicDoctorList',
        component: () => import('@/views/clinic/doctor/list.vue'),
        meta: {
          title: '医生管理',
          keepAlive: false
        }
      },
      {
        path: '/admin/clinic/admin/list',
        name: 'ClinicAdminList',
        component: () => import('@/views/clinic/admin/list.vue'),
        meta: {
          title: '人员管理',
          keepAlive: false
        }
      },
      {
        path: '/admin/clinic/doctor/commission',
        name: 'ClinicDoctorCommission',
        component: () => import('@/views/clinic/doctor/commission.vue'),
        meta: {
          title: '提成设置',
          keepAlive: false
        }
      }
    ]
  },
  {
    path: '/admin/clinic/doctor/edit',
    name: 'ClinicDoctorEdit',
    component: () => import('@/views/clinic/doctor/edit'),
    meta: {
      title: '医生编辑',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/dispensing',
    name: 'ClinicPharmacyDispensing',
    component: () => import('@/views/clinic/pharmacy/dispensing.vue'),
    meta: {
      title: '接单发药',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/order',
    name: 'ClinicPharmacyOrder',
    component: () => import('@/views/clinic/pharmacy/order.vue'),
    meta: {
      title: '订单',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/pharmacy/order/dtl',
    name: 'ClinicPharmacyOrderDtl',
    component: () => import('@/views/clinic/pharmacy/order_dtl.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/reception/appointment_scheduling',
    name: 'ClinicAppointmentScheduling',
    component: () => import('@/views/clinic/reception/appointment_scheduling'),
    children: [{
      path: '/admin/clinic/reception/outpatient_appointment',
      name: 'ClinicOutpatientAppointment',
      component: () => import('@/views/clinic/reception/outpatient_appointment'),
      meta: {
        title: '门诊预约',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/reception/subscribe_list',
      name: 'ClinicSubscribeList',
      component: () => import('@/views/clinic/reception/subscribe_list'),
      meta: {
        title: '预约列表',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/reception/reservation_queue',
      name: 'ClinicReservationQueue',
      component: () => import('@/views/clinic/reception/reservation_queue'),
      meta: {
        title: '预约排队',
        keepAlive: false
      }
    },  {
      path: '/admin/clinic/reception/subscribe_bed',
      name: 'ClinicSubscribeBed',
      component: () => import('@/views/clinic/reception/subscribe_bed'),
      meta: {
        title: '预约项目',
        keepAlive: false
      }
    },{
      path: '/admin/clinic/reception/queuing_settings',
      name: 'ClinicQueuingSettings',
      component: () => import('@/views/clinic/reception/queuing_settings'),
      meta: {
        title: '排队设置',
        keepAlive: false
      }
    }],
  },
  {
    path: '/admin/clinic/doctor/onlineConsult',
    name: 'ClinicOnlineConsult',
    component: () => import('@/views/clinic/doctor/online_consult.vue'),
    meta: {
      title: '线上看诊',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/doctor/visit_settings',
    name: 'ClinicDoctorVisitSettings',
    component: () => import('@/views/clinic/doctor/visit_settings.vue'),
    meta: {
      title: '看诊设置',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/doctor/today_seeDoctor',
    name: 'ClinicDoctorTodaySeeDoctor',
    component: () => import('@/views/clinic/doctor/today_seeDoctor.vue'),
    meta: {
      title: '今日就诊',
      keepAlive: false,
    },
  },
  {
    path: '/admin/clinic/doctor/clinic_about',
    name: 'ClinicDoctorAbout',
    component: () => import('@/views/clinic/doctor/clinic_about.vue'),
    meta: {
      title: '门诊预约',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/register/add',
    name: 'ClinicRegisterAdd',
    component: () => import('@/views/clinic/register/add_register.vue'),
    meta: {
      title: '新增挂号',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/doctor/todayconsultation',
    name: 'ClinicDoctorTodayconsultation',
    component: () => import('@/views/clinic/doctor/todayconsultation.vue'),
    meta: {
      title: '就诊单',
      keepAlive: false
    },
  },
  {
    path: '/admin/clinic/register/list',
    name: 'ClinicRegisterList',
    component: () => import('@/views/clinic/register/register_list.vue'),
    meta: {
      title: '挂号记录',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/outpatient/list',
    name: 'ClinicOutpatientList',
    component: () => import('@/views/clinic/outpatient/list.vue'),
    meta: {
      title: '门店列表',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/outpatient/classify',
    name: 'ClinicOutpatientClassify',
    component: () => import('@/views/clinic/outpatient/classify.vue'),
    meta: {
      title: '门店分类',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/outpatient/template_config',
    name: 'ClinicTemplateConfig',
    component: () => import('@/views/clinic/outpatient/template_config.vue'),
    meta: {
      title: '模板消息',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/outpatient/addEdit',
    name: 'ClinicOutpatientAddEdit',
    component: () => import('@/views/clinic/outpatient/addEdit.vue'),
    meta: {
      title: '新增门店',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/outpatient/project_list',
    name: 'ClinicOutpatientProjectList',
    component: () => import('@/views/clinic/outpatient/project_list.vue'),
    meta: {
      title: '项目列表',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/outpatient/appointment_record',
    name: 'AppointmentRecord',
    component: () => import('@/views/clinic/outpatient/appointment_record.vue'),
    meta: {
      title: '项目列表',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/project/list',
    name: 'ClinicProjectList',
    component: () => import('@/views/clinic/project/list.vue'),
    meta: {
      title: '门店项目',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/project/add',
    name: 'ClinicProjectAdd',
    component: () => import('@/views/clinic/project/add.vue'),
    meta: {
      title: '新增项目',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/admin/create',
    name: 'ClinicAdminCreate',
    component: () => import('@/views/clinic/admin/create.vue'),
    meta: {
      title: '人员编辑',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/manage/charge_manage',
    name: 'ClinicManageChargeManage',
    component: () => import('@/views/clinic/manage/charge_manage'),
    children: [{
      path: '/admin/clinic/manage/stay_charge',
      name: 'ClinicManageStayCharge',
      component: () => import('@/views/clinic/manage/stay_charge'),
      meta: {
        title: '待收费',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/manage/charged',
      name: 'ClinicManageCharged',
      component: () => import('@/views/clinic/manage/charged'),
      meta: {
        title: '已收费',
        keepAlive: false
      }
    }, {
      path: '/admin/clinic/manage/charge',
      name: 'ClinicManageCharge',
      component: () => import('@/views/clinic/manage/charge'),
      meta: {
        title: '挂账',
        keepAlive: false
      }
    }],
  },
  {
    path: '/admin/clinic/manage/charge_edit',
    name: 'ClinicManageChargeEidt',
    component: () => import('@/views/clinic/manage/charge_edit'),
    meta: {
      title: '收费',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/finance/flow_details',
    name: 'ClinicFinanceFlowDetails',
    component: () => import('@/views/clinic/finance/flow_details'),
    meta: {
      title: '财务-流水明细',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/finance/medical_statistics',
    name: 'ClinicFinanceMedicalStatistics',
    component: () => import('@/views/clinic/finance/medical_statistics'),
    meta: {
      title: '财务-医务统计',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/finance/income',
    name: 'ClinicFinanceIncome',
    component: () => import('@/views/clinic/finance/income'),
    meta: {
      title: '财务-医生提成',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/finance/insurance',
    name: 'ClinicFinanceInsurance',
    component: () => import('@/views/clinic/finance/insurance'),
    meta: {
      title: '财务-保险管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/finance/reconcile',
    name: 'ClinicFinanceReconcile',
    component: () => import('@/views/clinic/finance/reconcile'),
    meta: {
      title: '财务-收款对账',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/finance/reconcile/detail',
    name: 'ClinicFinanceReconcileDetail',
    component: () => import('@/views/clinic/finance/reconcile_detail'),
    meta: {
      title: '财务-收款对账-对账详情',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/doctor/faceToFace',
    name: 'ClinicDoctorFaceToFace',
    component: () => import('@/views/clinic/doctor/faceToFace'),
    meta: {
      title: '医生-面对面看诊',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/patient/medicalRecord',
    name: 'ClinicPatientMedicalRecord',
    component: () => import('@/views/clinic/patient/medicalRecord'),
    meta: {
      title: '病历查询',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/patient/follow',
    name: 'ClinicPatientFollow',
    component: () => import('@/views/clinic/patient/follow'),
    meta: {
      title: '待随访',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/patient/followed_up',
    name: 'ClinicPatientFollowedUp',
    component: () => import('@/views/clinic/patient/followed_up'),
    meta: {
      title: '已随访',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/patient/follow_template',
    name: 'ClinicPatientFollowTemplate',
    component: () => import('@/views/clinic/patient/follow_template'),
    meta: {
      title: '随访模板',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/patient/user_list',
    name: 'ClinicPatientUserList',
    component: () => import('@/views/clinic/patient/user_list'),
    meta: {
      title: '会员管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/patient/acard_dministration',
    name: 'ClinicPatientAcardDministration',
    component: () => import('@/views/clinic/patient/acard_dministration'),
    meta: {
      title: '次卡管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/patient/user_info',
    name: 'ClinicPatientUserInfo',
    component: () => import('@/views/clinic/patient/user_info'),
    meta: {
      title: '会员详情',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/outpatient/all_config',
    name: 'ClinicOutpatientAllClinicConfig',
    component: () => import('@/views/clinic/outpatient/all_config.vue'),
    meta: {
      title: '门店设置',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/data/patient_statistics',
    name: 'ClinicDataPatientStatistics',
    component: () => import('@/views/clinic/data/patient_statistics.vue'),
    meta: {
      tittle: '患者统计',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/data/report/opday',
    name: 'ClinicDataReportOpday',
    component: () => import('@/views/clinic/data/report_opday'),
    meta: {
      tittle: '经营日报',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/data/doctor_statistics',
    name: 'ClinicDataDoctorStatistics',
    component: () => import('@/views/clinic/data/doctor_statistics.vue'),
    meta: {
      title: '医生统计',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/data/prescription_statistics',
    name: 'ClinicDataPrescriptionStatistics',
    component: () => import('@/views/clinic/data/prescription_statistics.vue'),
    meta: {
      title: '药房统计',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/finance/income_dtl',
    name: 'ClinicFinanceIncomeDtl',
    component: () => import('@/views/clinic/finance/income_dtl'),
    meta: {
      title: '收入详情',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/data/home',
    name: 'ClinicDataHome',
    component: () => import('@/views/clinic/data/home.vue'),
    meta: {
      title: '数据大屏',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/outpatient/home',
    name: 'ClinicOutpatientHome',
    component: () => import('@/views/clinic/outpatient/home.vue'),
    meta: {
      title: '数据面板',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/patient/depositCardList',
    name: 'ClinicPatientDepositCardList',
    component: () => import('@/views/clinic/patient/patientDepositCardList.vue'),
    meta: {
      title: '储蓄卡列表',
      keepAlive: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/clinic.js